module.exports = __webpack_public_path__ + "img/DICH_VU_CONG_N.G.O.5bd42357.svg";